import type { ReactNode } from 'react'

type Props = {
  children: ReactNode
}

export const BannerLeft = ({ children }: Props) => {
  return <div className="flex flex-col justify-between">{children}</div>
}
